module.exports = __webpack_public_path__ + "88c8fd30c2223dfe1f235854e5d888fc.png";